{
  "R": [94, 50, 90, 152, 215, 238, 249, 254, 252, 241, 209, 158],
  "G": [79, 131, 186, 214, 240, 244, 237, 210, 157, 100, 57, 1],
  "B": [162, 189, 167, 164, 155, 169, 168, 123, 86, 68, 79, 66],
  "A": [0, 12, 23, 35, 47, 58, 70, 81, 93, 105, 116, 128],
  "I": [0, 23, 46, 70, 93, 116, 139, 162, 185, 209, 232, 255]
}
